import React, { useEffect, useState } from 'react'
import { useUserContext } from '../../context/users/UserContext'
import { validatePermissions } from '../../context/users/UserActions'
import { NavLink } from 'react-router-dom'
import { handleGetReport, obtenerDominio } from "../../utils/utilsFunct"
import { 
  FaUser, 
  FaUsers, 
  FaTable, 
  FaQuestion, 
  FaImages, 
  FaList, 
  FaCalendarAlt, 
  FaChartBar, 
  FaVideo,
  FaBook,
  FaSignOutAlt,
  FaChevronLeft,
  FaHome,
  FaIdCard,
  FaCreditCard
} from 'react-icons/fa'
import './Sidebar.css'
import DevelemosLogo from './assets/Logo principal recortado.png'

const keyToken = process.env.REACT_APP_SESSION_KEY || 'alleanza_jwtoken'

const COMPRA_PLANES_URL = 'https://develemos.com/adquirir'

export const getDomain = () => {
  var hostname = window.location.hostname.split('.')
  return hostname.slice(-2).join('.')
}

const Sidebar = ({ isMobileMenuOpen, onMobileMenuClose }) => {
  const { isAuthenticated, logOutUser, authenticatedUser } = useUserContext()
  const [isVisible, setIsVisible] = useState(true)
  const [isCollapsed, setIsCollapsed] = useState(false)

  useEffect(() => {
    setIsVisible(!window.location.pathname.includes('/sesion/'))
  }, [])

  const handleSignOut = () => {
    localStorage.removeItem(keyToken)
    logOutUser({})
    window.location = '/'
  }

  const handleSignOutWithMenuClose = () => {
    handleSignOut()
    handleMobileMenuClose()
  }

  function sendToCanvas(sessionCode) {
    localStorage.setItem('alleanza_currentSession', JSON.stringify({ sessionCode }))
    window.open(`${window.location.origin}/sesion/${sessionCode}`, "_blank")
  }

  function redirectToEncuesta() {
    var currentProtocol = window.location.protocol
    var currentDomain = obtenerDominio()
    var encuestaURL = currentProtocol + "//encuesta." + currentDomain + "/"
    console.log(encuestaURL)
    window.open(encuestaURL, "_blank")
  }


  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed)
  }

  const handleMobileMenuClose = () => {
    if (onMobileMenuClose) {
      onMobileMenuClose()
    }
  }

  // Close mobile menu when clicking on nav items
  const handleNavClick = () => {
    if (window.innerWidth <= 768) {
      handleMobileMenuClose()
    }
  }

  if (!isAuthenticated) return null

  // Ocultar GESTIÓN si no hay ningún ítem (evita título vacío).
  // HERRAMIENTAS siempre muestra al menos «Manuales de uso».
  const hasAnyGestion =
    validatePermissions(authenticatedUser.permissions, 'perfil') ||
    validatePermissions(authenticatedUser.permissions, 'users') ||
    validatePermissions(authenticatedUser.permissions, 'plans') ||
    validatePermissions(authenticatedUser.permissions, 'questions') ||
    validatePermissions(authenticatedUser.permissions, 'photos')
  return (
    <div className={`modern-sidebar ${isCollapsed ? 'collapsed' : ''} ${!isVisible ? 'hidden' : ''} ${isMobileMenuOpen ? 'show' : ''}`}>
      {/* Header */}
              <div className="sidebar-header">
          <div className="sidebar-brand">
            <div className="brand-logo">
              <img src={DevelemosLogo} alt="Develemos" className="develemos-logo" />
            </div>
          </div>
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            <FaChevronLeft />
          </button>
        </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {/* Main Navigation */}
        <div className="nav-section">
          <div className="nav-section-title">BIENVENIDO</div>
          
          <NavLink to='/home' className="nav-item" activeclassname='active' onClick={handleNavClick}>
            <FaHome className="nav-icon" />
            {!isCollapsed && <span>Inicio</span>}
          </NavLink>
        </div>

        {/* HERRAMIENTAS: Manuales antes que Tutoriales; Licencias/Compra planes según permisos */}
        <div className="nav-section">
          <div className="nav-section-title">HERRAMIENTAS</div>

          {validatePermissions(authenticatedUser.permissions, 'membership') && (
            <NavLink to='/Licencias' className="nav-item" activeclassname='active' onClick={handleNavClick}>
              <FaIdCard className="nav-icon" />
              {!isCollapsed && <span>Licencias</span>}
            </NavLink>
          )}

          {validatePermissions(authenticatedUser.permissions, 'selectPlan') && (
            <a
              href={COMPRA_PLANES_URL}
              className="nav-item"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleNavClick}
            >
              <FaCreditCard className="nav-icon" />
              {!isCollapsed && <span>Compra planes</span>}
            </a>
          )}

          <NavLink to='/manuales' className="nav-item" activeclassname='active' onClick={handleNavClick}>
            <FaBook className="nav-icon" />
            {!isCollapsed && <span>Manuales de uso</span>}
          </NavLink>

          {(validatePermissions(authenticatedUser.permissions, 'isHost') || validatePermissions(authenticatedUser.permissions, 'isAdmin')) && (
            <NavLink to='/tutoriales' className="nav-item" activeclassname='active' onClick={handleNavClick}>
              <FaVideo className="nav-icon" />
              {!isCollapsed && <span>Tutoriales</span>}
            </NavLink>
          )}
        </div>

        {/* Management Section - solo se muestra si tiene al menos una opción */}
        {hasAnyGestion && (
        <div className="nav-section">
          <div className="nav-section-title">GESTIÓN</div>
          
          {validatePermissions(authenticatedUser.permissions, 'perfil') && (
            <NavLink to='/informacionPersonal' className="nav-item" activeclassname='active' onClick={handleNavClick}>
              <FaUser className="nav-icon" />
              {!isCollapsed && <span>Información personal</span>}
            </NavLink>
          )}

          {validatePermissions(authenticatedUser.permissions, 'users') && (
            <NavLink to='/usuarios' className="nav-item" activeclassname='active' onClick={handleNavClick}>
              <FaUsers className="nav-icon" />
              {!isCollapsed && <span>Usuarios</span>}
            </NavLink>
          )}

          {validatePermissions(authenticatedUser.permissions, 'plans') && (
            <NavLink to='/planes' className="nav-item" activeclassname='active' onClick={handleNavClick}>
              <FaTable className="nav-icon" />
              {!isCollapsed && <span>Planes</span>}
            </NavLink>
          )}

          {validatePermissions(authenticatedUser.permissions, 'questions') && (
            <NavLink to='/preguntas' className="nav-item" activeclassname='active' onClick={handleNavClick}>
              <FaQuestion className="nav-icon" />
              {!isCollapsed && <span>Preguntas</span>}
            </NavLink>
          )}

          {validatePermissions(authenticatedUser.permissions, 'photos') && (
            <NavLink to='/fotografias' className="nav-item" activeclassname='active' onClick={handleNavClick}>
              <FaImages className="nav-icon" />
              {!isCollapsed && <span>Fotografías</span>}
            </NavLink>
          )}
        </div>
        )}

        {/* Sessions Section */}
        <div className="nav-section">
          <div className="nav-section-title">SESIONES</div>
          
          <NavLink to='/sessions' className="nav-item" activeclassname='active' onClick={handleNavClick}>
            <FaList className="nav-icon" />
            {!isCollapsed && <span>Sesiones</span>}
          </NavLink>
          
          <NavLink to='/reportes' className="nav-item" activeclassname='active' onClick={handleNavClick}>
            <FaCalendarAlt className="nav-icon" />
            {!isCollapsed && <span>Reporte de sesiones</span>}
          </NavLink>
          
          {validatePermissions(authenticatedUser.permissions, 'isAdmin') && (
            <NavLink to='/reporte' className="nav-item" activeclassname='active' onClick={handleNavClick}>
              <FaChartBar className="nav-icon" />
              {!isCollapsed && <span>Reporte de encuestas</span>}
            </NavLink>
          )}
        </div>

        {/* Logout */}
        <div className="nav-section logout-section">
          <button onClick={handleSignOutWithMenuClose} className="nav-item logout-item">
            <FaSignOutAlt className="nav-icon" />
            {!isCollapsed && <span>Salir</span>}
          </button>
        </div>
      </nav>
    </div>
  )
}

export default Sidebar
